"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSelect = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const types_1 = require("evolution-common/lib/services/questionnaire/types");
const surveyHelper = __importStar(require("evolution-common/lib/utils/helpers"));
const InputSelectOption = (props) => {
    if (props.choice.hidden === true ||
        !surveyHelper.parseBoolean(props.choice.conditional, props.interview, props.path, props.user)) {
        return null;
    }
    return (react_1.default.createElement("option", { key: `input-select-container__${props.choice.value}`, value: props.choice.value, className: 'input-select-option' }, surveyHelper.translateString(props.choice.label, props.i18n, props.interview, props.path, props.user)));
};
const InputSelectOptionT = (0, react_i18next_1.withTranslation)()(InputSelectOption);
const InputSelect = (props) => {
    const widgetChoices = props.widgetConfig.choices;
    const choices = typeof widgetChoices === 'function' ? widgetChoices(props.interview, props.path, props.user) : widgetChoices;
    let isGrouped = false;
    const selectOptions = choices.map((choice, optIdx) => {
        if ((0, types_1.isGroupedChoice)(choice)) {
            isGrouped = true;
            const groupSelectOptions = choice.choices.map((groupedChoice, index) => (react_1.default.createElement(InputSelectOptionT, { key: `${props.id}_opt_${optIdx}_${index}`, choice: groupedChoice, path: props.path, interview: props.interview, user: props.user })));
            const groupLabel = surveyHelper.translateString(choice.groupLabel, props.i18n, props.interview, props.path, props.user);
            return (0, LodashExtensions_1._isBlank)(groupLabel) ? (react_1.default.createElement(react_1.default.Fragment, { key: `input-select-group-container_${optIdx}` },
                react_1.default.createElement("option", { key: `input-select-container__disabled_${optIdx}`, disabled: true }, "_________"),
                groupSelectOptions)) : (react_1.default.createElement("optgroup", { key: `input-select-group-container__${choice.groupShortname}`, label: groupLabel }, groupSelectOptions));
        }
        else {
            return (react_1.default.createElement(InputSelectOptionT, { key: `${props.id}_opt_${choice.value}`, choice: choice, path: props.path, interview: props.interview, user: props.user }));
        }
    }, this);
    return (react_1.default.createElement("div", { className: "survey-question__input-select-container" },
        react_1.default.createElement("select", { id: props.id, onChange: props.onValueChange, value: (0, LodashExtensions_1._isBlank)(props.value) ? '' : props.value, style: {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                maxWidth: '100%'
            } },
            react_1.default.createElement("option", { key: 'input-select-container__blank', value: "", className: 'input-select-option' }),
            selectOptions,
            isGrouped === false && (react_1.default.createElement("optgroup", { key: "-1", label: "" })) /* if no group, add an empty group (hack) to make sure <option> with long text are not truncated on small width screens (iphone) */)));
};
exports.InputSelect = InputSelect;
exports.default = (0, react_i18next_1.withTranslation)()(exports.InputSelect);
//# sourceMappingURL=InputSelect.js.map